import {
	IconBracketsCurlyOutline18 as ParamFieldIcon,
	IconBracketsSquareDotsOutline18 as ResponseFieldIcon,
} from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/fields"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const paramFieldCommand: SlashCommandDefinition = {
	key: "param-field",
	title: "Parameter field",
	icon: <ParamFieldIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertParamField().run()
	},
	group: "blocks",
	aliases: [
		"param",
		"parameter",
		"param field",
		"query parameter",
		"path parameter",
		"body parameter",
		"header",
		"api",
		"request",
	],
}

export const responseFieldCommand: SlashCommandDefinition = {
	key: "response-field",
	title: "Response field",
	icon: <ResponseFieldIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertResponseField().run()
	},
	group: "blocks",
	aliases: [
		"response",
		"response field",
		"field",
		"property",
		"api",
		"return value",
	],
}
